var styles = {
  "Details": "Polaris-TopBar-UserMenu__Details"
};

export { styles as default };
